var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._b({attrs:{"solo":"","items":_vm.tableItems,"clearable":!_vm.$attrs.readOnly,"loading":_vm.isLoading,"readonly":_vm.$attrs.readOnly},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'v-autocomplete',_vm.resetProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }